import { IonIcon } from "@/components/icons/AppIcon";
import SectionHeading from "@/components/home/SectionHeading";
import { LoginButton, OpenAppButton } from "@/components/AppButtons";

const POINTS = [
  { icon: "person-outline", text: "Log in met hetzelfde account als in de app." },
  { icon: "desktop-outline", text: "Teken en bewerk je jachtgebieden op een groter scherm." },
  { icon: "phone-portrait-outline", text: "Wat je opslaat, zie je ook in de app op je telefoon." },
];

export default function WebAppSection() {
  return (
    <section id="computer" data-testid="webapp-section" className="border-t border-[#2C2E29] bg-[#161714] py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <SectionHeading eyebrow="Op de computer" title="Waidbook in je browser.">
            Tekenen en gedetailleerd bewerken van jachtgebieden werkt het best op
            een groter scherm. Web en telefoon gebruiken dezelfde gegevens zolang
            je met hetzelfde account inlogt: beide werken met dezelfde
            Waidbook-omgeving.
          </SectionHeading>
          <div className="flex flex-col gap-3 sm:flex-row">
            <OpenAppButton testid="webapp-open-waidbook-btn" />
            <LoginButton testid="webapp-login-btn" />
          </div>
        </div>
        <ul className="grid gap-4 self-center lg:col-span-6">
          {POINTS.map((p, i) => (
            <li
              key={i}
              data-testid={`webapp-point-${i}`}
              className="flex items-center gap-5 rounded-2xl border border-[#2C2E29] bg-[#1C1D1A] p-5"
            >
              <span className="icon-tile shrink-0">
                <IonIcon name={p.icon} />
              </span>
              <span className="text-sm leading-relaxed text-[#EAEBE7] md:text-base">{p.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
